export const ERoutes = {
  SALE_DATA: "/saleData",
  NOZEL_DATA: "/nozelData",
  TANK_DATA: "/tankData",
  SALE_REGISTER: "/saleRegister"
};
